/* global toastr $ */

import React, { Component } from 'react'
import AttrInput from '../smart_bps/lib/attr_input'

const MODAL_ID = 'modal_upload_access_objects'

export class AccessObjectsUploadModal extends Component {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onDownloadExample = this.onDownloadExample.bind(this)
    this.onDownloadErrorFile = this.onDownloadErrorFile.bind(this)
    this.loadDefaults = this.loadDefaults.bind(this)
    this.ref_upload_file = React.createRef()
    this.state = {
      organization_id: undefined,
      lock_organization: false,
      error: undefined,
      uploading: false,
    }
  }

  onChange(name, value) {
    this.setState({ [name]: value, error: undefined })
  }

  componentDidMount() {
    $(`#${MODAL_ID}`).on('show.bs.modal', this.loadDefaults)
    $(`#${MODAL_ID}`).on('hidden.bs.modal', () => {
      this.setState({
        organization_id: undefined,
        lock_organization: false,
        error: undefined,
        uploading: false,
      })
      if (this.ref_upload_file.current) {
        this.ref_upload_file.current.value = ''
      }
    })
  }

  componentWillUnmount() {
    $(`#${MODAL_ID}`).off('show.bs.modal', this.loadDefaults)
    $(`#${MODAL_ID}`).off('hidden.bs.modal')
  }

  loadDefaults() {
    const token = localStorage.getItem('auth_access_token')
    fetch(`/api/${this.props.project_name}/upload_defaults`, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((response) => {
        if (!response.ok) throw new Error('Ошибка загрузки значений по умолчанию')
        return response.json()
      })
      .then((data) => {
        const organization_id = data.organization_id ?? undefined
        this.setState({
          organization_id,
          lock_organization: Boolean(data.lock_organization),
          error: undefined,
        })
      })
      .catch(() => {
        // Оставляем текущее поведение как fallback.
      })
  }

  filesSelected(e) {
    const input = e.target
    const file = input.files && input.files[0]
    if (!file) return

    const organization_id = this.state.organization_id
    if (!organization_id) {
      this.setState({ error: 'Выберите контрагента' })
      return
    }

    this.setState({ uploading: true })

    const formData = new FormData()
    formData.append('file', file)
    formData.append('organization_id', organization_id)

    const token = localStorage.getItem('auth_access_token')
    fetch(`/api/${this.props.project_name}/upload_objects`, {
      method: 'POST',
      body: formData,
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(err.detail || 'Ошибка при загрузке файла')
          })
        }
        return response.json()
      })
      .then((data) => {
        if (data.error) {
          toastr.error(data.error)
        } else {
          const n = data.created_count || 0
          if (n > 0) {
            toastr.success(`Создано карточек: ${n}`)
          }
          const existingPassports = data.existing_passports

          if (existingPassports.length) {
            const text =
            'Вы попытались загрузить сотрудников, которые уже созданы в системе. Хотите ' +
            '<a href="#" style="color: #ff5a00;" class="download-error-file">скачать</a>' +
            ' файл со списком этих людей?'

            toastr.info(text, 'Информация по загрузке', {
              escapeHtml: false,
              timeOut: 0,
              extendedTimeOut: 0,
              closeButton: true,
              tapToDismiss: false,
            })

            // toastr прининимает дефолтный html, поэтому вешаем обработчки через addEventListener
            setTimeout(() => {
              const link = document.querySelector('.toast a.download-error-file')
              if (link) {
                link.addEventListener('click', function (e) {
                  e.preventDefault()
                  this.onDownloadErrorFile(file, existingPassports)
                }.bind(this))
              }
            }, 0)
          }
          const rowErrors = data.row_errors || []
          rowErrors.forEach(({ row, name, messages }) => {
            const rowLabel = name ? `строке ${row} (${name})` : `строке ${row}`
            const text = messages && messages.length
              ? `Ошибка в ${rowLabel}: ${messages.join('; ')}`
              : `Ошибка в ${rowLabel}: не заполнены обязательные поля`
            toastr.info(text, 'Информация по загрузке', { timeOut: 8000 })
          })
          if (n === 0 && rowErrors.length === 0) {
            if (existingPassports) {

            } else {
              toastr.info('Нет заполненных строк для загрузки (строка считается заполненной, если указано Имя)')
            }
          }
        }
        $(`#${MODAL_ID}`).modal('hide')
        this.setState({ uploading: false }, () => {
          if (this.props.onUploadSuccess) {
            this.props.onUploadSuccess()
          }
        })
        input.value = ''
      })
      .catch((err) => {
        toastr.error(err.message || 'Ошибка при загрузке файла')
        this.setState({ uploading: false })
        input.value = ''
      })
  }


  onDownloadErrorFile(file, existingPassports) {
     const token = localStorage.getItem('auth_access_token')
     const formData = new FormData()
     formData.append('file', file)
     existingPassports.forEach(passport => {
       formData.append('existing_passports', String(passport))
     })

     fetch(`/api/${this.props.project_name}/download_upload_error_xlsx`, {
      method: 'POST',
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
      body: formData
    })
      .then((response) => {
        if (!response.ok) throw new Error('Ошибка при скачивании')
        return response.blob()
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'Сотрудники, имеющие карточку в системе.xlsx'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
      .catch(() => toastr.error('Ошибка при скачивании'))
  }


  onDownloadExample(e) {
    e.preventDefault()
    const token = localStorage.getItem('auth_access_token')
    fetch(`/api/${this.props.project_name}/download_upload_template`, {
      method: 'GET',
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    })
      .then((response) => {
        if (!response.ok) throw new Error('Ошибка при скачивании')
        return response.blob()
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'Форма загрузки посетителей.xlsx'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
      .catch(() => toastr.error('Ошибка при скачивании примера файла'))
  }

  onSubmit() {
    const organization_id = this.state.organization_id
    if (!organization_id) {
      this.setState({ error: 'Выберите контрагента' })
      return
    }
    this.ref_upload_file.current.click()
  }

  render() {
    const { organization_id, lock_organization, error, uploading } = this.state

    return (
      <div className="modal fade" id={MODAL_ID} tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel1">
                <i className="ti ti-upload me-1"></i>
                Массовая загрузка
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {error && <div className="alert alert-danger">{error}</div>}
              <AttrInput
                data_type="integer"
                name="organization_id"
                title="Контрагент"
                value={organization_id}
                choice_name="ContractorOrganization"
                access={lock_organization ? 'read' : 'edit'}
                onChange={this.onChange}
                widget="select2"
              />
              <input
                className="d-none"
                type="file"
                accept=".xlsx,.xls"
                ref={this.ref_upload_file}
                onChange={(e) => this.filesSelected(e)}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary p-2 me-1"
                onClick={this.onSubmit}
                disabled={uploading}
              >
                <span className="ti ti-upload me-1"></span>
                {uploading ? 'Загрузка...' : 'Загрузить'}
              </button>
              <button type="button" className="btn btn-secondary p-2 me-1" data-bs-dismiss="modal">
                Закрыть
              </button>
              <a href="#" className="p-2 me-1" onClick={this.onDownloadExample}>
                <i className="ti ti-download me-1"></i>
                Пример файла
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
